import {SimpleTextFormatter} from "../SimpleTextFormatter";
import {MultipleSelectionFormatter} from "../MultipleSelectionFormatter";
import {NameFormatter} from "../NameFormatter";
import {AddressFormatter} from "../AddressFormatter";
import {DateFormatter} from "../DateFormatter";
import {FileUploadFormatter} from "../FileUploadFormatter";

export class FormatterFactory {
    public static GetFormatter(field:FieldDTO,data:any)
    {
        if(rednaoEntries._prefix=="rednaopdfninja")
            return FormatterFactory.GetFormatterNinja(field,data);

        switch(field.SubType)
        {
            case 'text':
            case 'textbox':
            case 'email':
            case 'password':
            case "phone":
            case "hidden":
            case 'payment-single':
            case 'textarea':
            case 'payment-total':
            case 'website':
            case 'number':
            case 'time':
            case 'post_title':
            case 'post_content':
            case 'post_excerpt':
            case 'post_tags':
            case 'post_category':
            case 'post_custom_field':
            case 'product':
            case 'quantity':
            case 'shipping':
            case 'total':
            case 'url':
            case 'date-time':
            case 'file-upload':
            case 'firstname':
            case 'lastname':
            case 'city':
            case 'liststate':
            case 'zip':
            case 'listcountry':
            case 'listradio':
            case 'listselect':
            case 'confirm':
            case 'starrating':
                return new SimpleTextFormatter().Initialize(field,data);
            case 'radio':
            case 'checkbox':
            case 'payment-multiple':
            case 'select':
            case 'multiselect':
            case 'option':
            case 'list':
            case 'payment-select':
                return new MultipleSelectionFormatter().Initialize(field,data);
            case 'name':
                return new NameFormatter().Initialize(field,data);
            case 'address':
                return new AddressFormatter().Initialize(field,data);
            case 'date':
                return new DateFormatter().Initialize(field,data);
            case 'fileupload':
            case 'post_image':
                return new FileUploadFormatter().Initialize(field,data);
            default:
                throw Error("Invalid format type "+field.SubType);
        }
    }

    private static GetFormatterNinja(field: FieldDTO, data: any) {
        switch(field.SubType)
        {
            case 'text':
            case 'textbox':
            case 'email':
            case 'password':
            case "phone":
            case "hidden":
            case 'payment-single':
            case 'textarea':
            case 'payment-total':
            case 'website':
            case 'number':
            case 'time':
            case 'post_title':
            case 'post_content':
            case 'post_excerpt':
            case 'post_tags':
            case 'post_category':
            case 'post_custom_field':
            case 'product':
            case 'quantity':
            case 'shipping':
            case 'total':
            case 'url':
            case 'date-time':
            case 'date':
            case 'file-upload':
            case 'firstname':
            case 'lastname':
            case 'city':
            case 'liststate':
            case 'zip':
            case 'listcountry':
            case 'listradio':
            case 'listselect':
            case 'confirm':
            case 'starrating':
            case 'checkbox':
                return new SimpleTextFormatter().Initialize(field,data);
            case 'listcheckbox':
            case 'listmultiselect':
                return new MultipleSelectionFormatter().Initialize(field,data);
            case 'name':
                return new NameFormatter().Initialize(field,data);
            case 'address':
                return new AddressFormatter().Initialize(field,data);
            case 'file_upload':
            case 'post_image':
                return new FileUploadFormatter().Initialize(field,data);

            default:
                throw Error("Invalid format type "+field.SubType);
        }
    }
}